export default __webpack_public_path__ + "static/media/user-light.8baa21d7.svg";